import { TZDate } from '@date-fns/tz';

/** Local calendar date (YYYY-MM-DD) of an instant in a location's timezone. */
export function localDate(instant: Date, timeZone: string): string {
  const d = new TZDate(instant, timeZone);
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mm}-${dd}`;
}

/** Wall-clock label, e.g. "5:15 PM". */
export function localTime(instant: Date, timeZone: string, locale = 'en-US'): string {
  return new Intl.DateTimeFormat(locale, { hour: 'numeric', minute: '2-digit', timeZone }).format(
    instant,
  );
}

export function localDateLabel(instant: Date, timeZone: string, locale = 'en-US'): string {
  return new Intl.DateTimeFormat(locale, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    timeZone,
  }).format(instant);
}

export function addMinutes(d: Date, minutes: number): Date {
  return new Date(d.getTime() + minutes * 60_000);
}
